/**
 * Chat feature routes — the chat module's contribution to the authenticated
 * route tree (see src/features/routes-registry.ts for the contract).
 *
 * Chat mounts ONLY at 'chat' in the unified app. (In experts-web chat also owned
 * the index route path='' — that is DELETED here: the unified SHELL owns '/'
 * and redirects to the landing module, per the consolidation plan. ChatPage
 * renders inside the shell's ProtectedRoute + AppShell <Outlet>.) The chat
 * module owns everything under src/features/chat/ and touches no shell file
 * except adding chatRoutes to the registry.
 */
import { Route } from 'react-router';
import type {
  FeatureRouteList,
  FullBleedPathList,
} from '@/features/routes-registry';
import { ChatPage } from './ChatPage';

export const chatRoutes: FeatureRouteList = [
  <Route element={<ChatPage />} key="chat" path="chat" />,
];

/**
 * Chat is an app-style surface: it owns its own columns (conversation list,
 * transcript, artifact panel) and scroll regions, so it asks the shell for the
 * whole content area instead of the padded document gutter. Without this it
 * floated inside the gutter as a second column beside the shell rail (the
 * "double menu", 2026-10-17). Paths are absolute and match their subtree.
 */
export const chatFullBleedPaths: FullBleedPathList = ['/chat'];
